var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00005 0.299988C8.60756 0.299988 9.10005 0.792475 9.10005 1.39999V6.89999H14.6C15.2076 6.89999 15.7 7.39247 15.7 7.99999C15.7 8.6075 15.2076 9.09999 14.6 9.09999H9.10005V14.6C9.10005 15.2075 8.60756 15.7 8.00005 15.7C7.39254 15.7 6.90005 15.2075 6.90005 14.6V9.09999H1.40005C0.792536 9.09999 0.300049 8.6075 0.300049 7.99999C0.300049 7.39247 0.792536 6.89999 1.40005 6.89999L6.90005 6.89999V1.39999C6.90005 0.792475 7.39254 0.299988 8.00005 0.299988Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.ce630a10e644cafe20bbb0b3163a2372.svg";
export { ForwardRef as ReactComponent };